import React from 'react';
import { Flex, Spin} from 'antd';

const DefaultSkeleton = () => {
  return (
		<div className="main-wrapper">
      <div className="navigation">
        <div className="display-center navigation-inner-container" style={{ display: "flex", }}>
          <div className="logo" style={{ minWidth: "180px" }}>
            <div className="text-center width_100_per">
            </div>
          </div>
        </div>
      </div>
      <div className="flexbox-parent">
        <div className="fill-area">
          <Flex align="center" justify="center" style={{ width: '100%', height: '100vh'}}>
            <Spin percent='auto' fullscreen />
          </Flex>
        </div>
      </div>
		</div>
  );
};

export default DefaultSkeleton;
